import * as yup from "yup";

const expeditadoValidacionEsquema = yup.object().shape({
    tipoUnidad : yup.mixed().required(),
    cliente:yup.object({
        id: yup.number().required().min(1),
    }),
    subClienteId:yup.mixed().when("cliente.esLogistico",{
        is:true,
        then: yup.number().required().min(1)
    }),
    precioViaje: yup.number().required().min(1),
    comision: yup.number().required().min(0),
    expeditadoCentroCostos: yup.array().when("tieneCentroCostos", {
    is: true,
    then: (schema) => schema.min(1, ""),
    otherwise: (schema) => schema.notRequired()
    }),
    peso: yup.number().required().min(1),
    codigoRuta: yup.string().test(
        "matches",
        "El código de ruta es requerido",
        function (value) {
            const nombre = this.parent?.cliente?.nombre?.toLowerCase();
            const proveedor = this.parent?.proveedor;
            const aplicaFrightVerify = this.parent?.aplicaFrightVerify;
            const aplicaEdiAODMEX = this.parent?.aplicaEdiAODMEX;
            const esAptiv = nombre?.includes("aptiv");
            const esRequerido = esAptiv || ((proveedor?.length ?? 0) === 0 && (aplicaFrightVerify || aplicaEdiAODMEX));

            if (!esRequerido) {
                return true;
            }

            if ((value ?? "").trim().length === 0) {
                return this.createError({message: "El código de ruta es requerido"});
            }

            if (esAptiv && (value ?? "").length > 12) {
                return this.createError({message: "El código de ruta debe tener máximo 12 caracteres"});
            }

            return true;
        }
    )
});

export default expeditadoValidacionEsquema;
